import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ring-1 ring-black ring-opacity-5 sm:rounded-lg shadow" }
const _hoisted_2 = { class: "flex w-full justify-start sm:justify-end flex-wrap gap-2 bg-gray-50 py-3 px-2 rounded-t-lg" }
const _hoisted_3 = { class: "flex justify-start bg-white border-t p-2 rounded-b-lg flex-wrap gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "italic text-gray-600 p-1"
}

import { localFilterToProps, newFilterOptions } from '@/helpers/filters'


export default {
  __name: 'ListFilterEditor',
  props: {
  filters: { type: Array, default: () => [] }
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const localFilterToEvents = local => ({
  updateSelect: value => emit('change', { ...local, selection: value }),
  updateOperator: value => emit('change', { ...local, operator: value }),
  updateField: value => emit('change', { ...local, field: value }),
  updateUnit: value => emit('change', { ...local, unit: value }),
  updateSpecial: value => emit('change', { ...local, special: value }),
  updateReverse: value => emit('change', { ...local, reversed: value }),
  remove: () => emit('change', { ...local, destroy: true })
})

return (_ctx, _cache) => {
  const _component_NewFilterDropdown = _resolveComponent("NewFilterDropdown")
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NewFilterDropdown, {
        name: "Cart & payment filters",
        filters: _unref(newFilterOptions).cart,
        onAddFilter: _cache[0] || (_cache[0] = type => emit('change', { type }))
      }, null, 8, ["filters"]),
      _createVNode(_component_NewFilterDropdown, {
        name: "Fulfillment filters",
        filters: _unref(newFilterOptions).fulfillment,
        onAddFilter: _cache[1] || (_cache[1] = type => emit('change', { type }))
      }, null, 8, ["filters"]),
      _createVNode(_component_NewFilterDropdown, {
        name: "Contact filters",
        filters: _unref(newFilterOptions).contact,
        onAddFilter: _cache[2] || (_cache[2] = type => emit('change', { type }))
      }, null, 8, ["filters"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter) => {
        return (_openBlock(), _createBlock(_component_FilterDropdown, _mergeProps({
          key: filter.id
        }, { ref_for: true }, _unref(localFilterToProps)(filter), _toHandlers(localFilterToEvents(filter))), null, 16))
      }), 128)),
      (!__props.filters.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No filters selected"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}